<template>
  <div class="ui stackable grid">
    <div class="ten wide column">
      <table class="ui celled fixed padded unstackable table">
        <tbody>
          <tr v-for="(rowOfHints, rowId) in hints" :key="rowId">
            <td
              class="center aligned"
              v-for="(hint, hintId) in rowOfHints"
              :key="hintId"
            >
              <h1
                class="ui header"
                :class="{
                  [keywords[hint.keywordId].color]:
                    keywords[hint.keywordId].found || reviewModeEnabled
                }"
              >
                {{ hint.name }}
              </h1>
            </td>
          </tr>
        </tbody>
      </table>
      <keyword-panel
        :keywords="keywords"
        @clickedKeyword="markKeyword"
      ></keyword-panel>
    </div>
    <div class="six wide column">
      <scoreboard-vertical></scoreboard-vertical>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ScoreboardVertical from '@/components/elements/scoreboardVertical';
import KeywordPanel from '@/components/elements/keywordPanel';

export default {
  name: 'puzzel',
  components: { ScoreboardVertical, KeywordPanel },
  computed: {
    ...mapGetters(['reviewModeEnabled']),
    ...mapGetters('puzzel', ['activeQuestion']),
    keywords() {
      return this.$store.getters['puzzel/activeKeywords'];
    },
    hints() {
      return this.$store.getters['puzzel/activeHintsPerRow'];
    }
  },
  methods: {
    markKeyword(keywordId) {
      this.$store.dispatch('puzzel/answerQuestion', keywordId);
      this.$store.dispatch('syncGame');
    }
  }
};
</script>

<style scoped>
.ui.table {
  background: rgba(0, 0, 0, 0.15);
}
</style>
